<template>
  <div>
    <v-row id="a" no-gutters>
      <v-col cols="6" class="pr-2">
        <v-autocomplete
          v-model="digitalInputObject.digitalInputId"
          outlined
          :items="items"
          item-text="name"
          item-value="id"
          :label="digitalInput2Label"
          @change="incidentTypeIsSelected"
          dense
          hide-details="auto"
        />
      </v-col>
      <v-col cols="6" class="pl-2">
        <v-autocomplete
          :disabled="selectedDigitalInput.id == null"
          outlined
          v-model="selectedValue"
          :items="selectIncidentValue"
          item-text="text"
          item-value="value"
          :label="incidentTypeLabel"
          ref="digitalInput"
          dense
          hide-details="auto"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axiosClient from '@/api/httpClient'
import translate from '@/utils/genTable/multilanguageHelper.js'
export default {
  props: {
    digitalInputNumber: Number,
    value: {
      type: Object | String,
      default() {
        return {
          digitalInputId: null
        }
      }
    }
  },
  data() {
    return {
      items: [{ id: null, name: 'Izaberite...' }],
      title: this.$attrs.label,
      selectedValue: null,
      selectedDigitalInput: {
        id: null,
        value: null
      },
      digitalInputObject : {},
      valueNameOnZero: '0',
      valueNameOnOne: '1',
      incidentTypeLabel: translate(
        'Incident type',
        'fields.components.DigitalInputs'
      ),
      digitalInputLabel: translate(
        'Digital input',
        'fields.components.DigitalInputs'
      )
    }
  },
  computed: {
    selectIncidentValue: function() {
      return [
        {
          text: translate(
            'No incident',
            'fields.components.DigitalInputs.selectDigitalInput'
          ),
          value: false
        },
        {
          text: 'Incident - ' + this.valueNameOnZero, //translate("Incident on 0","fields.components.DigitalInputs.selectDigitalInput"),
          value: 0
        },
        {
          text: 'Incident - ' + this.valueNameOnOne, //translate("Incident on 1","fields.components.DigitalInputs.selectDigitalInput"),
          value: 1
        }
      ]
    },
    digitalInput2Label: function() {
      return (
        translate('DigitalInput', 'fields.components.DigitalInputs') +
        ' ' +
        this.digitalInputNumber
      )
    }
  },
  async created() {
    let response = await axiosClient.get('/digitalinputdevices')
    this.items = this.items.concat(response.data)
  },
  methods: {
    setValueForSelectedIncident() {
      if (this.value.isIncident) {
        if (this.value.incidentValue) {
          this.selectedValue = 1
        } else {
          this.selectedValue = 0
        }
      } else {
        this.selectedValue = false
      }
    },
    conertStringToNumber(string) {
      var integer = parseInt(string, 10)
      return integer
    },
    incidentTypeIsSelected() {
      this.$refs.digitalInput.focus()
      this.selectedDigitalInput = this.items.filter(
        x => x.id == this.digitalInputObject.digitalInputId
      )[0]
      if (this.selectedDigitalInput) {
        if (this.selectedDigitalInput.id != null) {
          this.valueNameOnZero = this.selectedDigitalInput.valueNameOnZero
          this.valueNameOnOne = this.selectedDigitalInput.valueNameOnOne
        }
      }
    }
  },
  watch: {
    selectedValue: {
      handler(){
        let digitalInputValue = {}
        digitalInputValue.digitalInputId = this.digitalInputObject.digitalInputId
        if (this.selectedValue === 0) {
          digitalInputValue.isIncident = true
          digitalInputValue.incidentValue = false
        } else if (this.selectedValue === 1) {
          digitalInputValue.isIncident = true
          digitalInputValue.incidentValue = true
        } else {
          digitalInputValue.isIncident = false
          digitalInputValue.incidentValue = false
        }
        this.digitalInputObject = digitalInputValue
      }
    },
    value: {
      handler() {
        if(this.value != null){
          this.digitalInputObject = this.value
          this.setValueForSelectedIncident()
          this.selectedDigitalInput = this.items.filter(
            x => x.id == this.value.digitalInputId
          )[0]
          if (this.selectedDigitalInput) {
            this.valueNameOnZero = this.selectedDigitalInput.valueNameOnZero
            this.valueNameOnOne = this.selectedDigitalInput.valueNameOnOne
          }
        }
      }
    },
    digitalInputObject: {
      handler(){
          this.$emit('input', this.digitalInputObject)
      }
    }
  }
}
</script>

<style lang="scss">
</style>